import { createFileRoute } from '@tanstack/react-router'
import { ProductsFeature } from '@/features/products/ProductsFeature'

export const Route = createFileRoute('/products')({
  component: ProductsPage,
})

function ProductsPage() {
  return <ProductsFeature />
}
